import { DRAWERS } from '@/voc/constants/overlays.js';

const state = {
    [DRAWERS.feedbackViews]: {
        rendered: false,
        visible: false,
        metadata: {},
    },
    [DRAWERS.ideaCreate]: {
        rendered: false,
        visible: false,
        metadata: {},
    },
    [DRAWERS.topic]: {
        rendered: false,
        visible: false,
        metadata: {},
    },
    [DRAWERS.automationRule]: {
        rendered: false,
        visible: false,
        metadata: {},
    },
};

const mutations = {
    openDrawer (state, { drawer, metadata }) {
        // If the drawer has not been rendered yet,
        // set rendered to true so that it is added to the DOM
        if (!state[drawer].rendered) state[drawer].rendered = true;

        state[drawer].visible = true;

        if (metadata) {
            state[drawer].metadata = { ...metadata };
        }
    },
    closeDrawer (state, { drawer }) {
        if (state[drawer].visible) {
            state[drawer].visible = false;
            state[drawer].metadata = {};
        }
    },
    closeAllDrawers (state) {
        Object.keys(state).forEach((drawer) => {
            if (state[drawer].visible) {
                state[drawer].visible = false;
                state[drawer].metadata = {};
            }
        });
    },
};

const actions = {
    closeAllDrawers ({ commit, getters }) {
        if (!getters.isAnyDrawerOpen) return;
        commit('closeAllDrawers');
    },
    openDrawer ({ commit }, { drawer, metadata }) {
        commit('openDrawer', { drawer, metadata });
    },
    closeDrawer ({ commit }, { drawer, metadata }) {
        commit('closeDrawer', { drawer, metadata });
    },
};

const getters = {
    isAnyDrawerOpen: (state) => Object.values(state).some((drawer) => drawer.visible),
    getDrawerMetadata: (state) => (drawer) => {
        return state[drawer].metadata;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
